import { Employees } from '~/data/employees';
import { OrganizationUnit } from '~/data/orgunits';
import { UserActivityEvent } from '~/data/userActivity';
import {
  UserActivityEventPayloadDtoTarget,
  UserActivityEventPayloadDtoType,
} from '~/services/Http/client.iam.generated';

export type EmployeeAndUnit = {
  employee: Employees | undefined;
  unit: OrganizationUnit | undefined;
};

export type UserActivityViewEventsRow = {
  id: number;
  userName: string;
  userUnit: string;
  eventType: string;
  resourceName: string;
  targetType: string;
  targetName: string;
  serverTime: Date;
  clientTime: Date;
  ipAddress: string;
  userAgent: string;
  meta: {
    eventData: UserActivityEvent;
    subjectData: EmployeeAndUnit;
  };
};

export const getEmployeeName = (employee: Employees) => {
  return `${employee.fEmpFirstName} ${employee.fEmpLastName}`;
};

export const getEventTypeTranslationKey = (
  type: UserActivityEventPayloadDtoType | undefined,
): string => {
  const translationKeys: {
    [key in UserActivityEventPayloadDtoType]: string;
  } = {
    [UserActivityEventPayloadDtoType.Read]: 'userActivityTypeRead',
    [UserActivityEventPayloadDtoType.Write]: 'userActivityTypeWrite',
  };

  return !!type ? translationKeys[type] : '';
};

export const getTargetTypeTranslationKey = (
  type: UserActivityEventPayloadDtoTarget | undefined,
): string => {
  const translationKeys: {
    [key in UserActivityEventPayloadDtoTarget]: string;
  } = {
    [UserActivityEventPayloadDtoTarget.Employee]: 'employee',
    [UserActivityEventPayloadDtoTarget.Unit]: 'laUnit',
    [UserActivityEventPayloadDtoTarget.Company]: 'laCompany',
    [UserActivityEventPayloadDtoTarget.Other]: 'laOther',
  };

  return !!type ? translationKeys[type] : '';
};
